// src/service/translate/trains/trainTranslations.nl-NL.ts
import type { TrainTranslations } from "./trainTranslations.types";

const trainNlTranslations: TrainTranslations = {
    trainPage: {
        title: "Trein",
        step: "Stap",
        resultsFound: "treinopties gevonden",
        stopOver: "Stop",
        stopOverPlural: "Stops",
        nextStep: "Volgende stap",
        loadingTimeline: "Dienstregeling laden…",
    },
    trainSortBy: {
        title: "Sorteren op",
        price_asc: "Laagste prijs eerst",
        price_desc: "Hoogste prijs eerst",
        fastest: "Snelste",
        fewest_changes: "Minste overstappen"
    },
    trainBlock: {
        title: "Treindienst",
        direct: "Direct",
    },
    trainFilters: {
        outboundTrip: {
            title: "Vertrektijden heenreis",
            duration: "Duur",
            departure: {
                location: "",
                time: "Vertrek"
            },
            arrival: {
                location: "Bestemmingsstation",
                time: "Aankomst"
            }
        },
        inboundTrip: {
            title: "Vertrektijden terugreis",
            duration: "Duur",
            departure: {
                location: "",
                time: "Vertrek"
            },
            arrival: {
                location: "",
                time: "Aankomst"
            }
        },
        operators: "Vervoerder",
        duration: "Reisduur"
    },
    stationsNames: {
        STP: "London St Pancras",
        EBB: "Ebbsfleet International",
        AFI: "Ashford International",
        CMF: "Chambéry-Savoie",
        XAP: "Aime La Plagne",
        XBM: "Bourg St Maurice",
        XBMA: "Bourg St Maurice",
        XAV: "Albertville",
        XMO: "Moutiers",
        XDB: "Lille Europe",
        PLY: "Parijs - Gare de Lyon",
        PEST: "Parijs - Gare de l'Est",
        AMS: "Amsterdam Centraal",
        RTM: "Rotterdam Centraal",
        ANR: "Antwerpen",
        BRU: "Brussel-Zuid",
        "Bourg-Saint-Maurice": "Bourg Saint Maurice",
        "Aime-la-Plagne": "Aime la Plagne",
        "Moûtiers": "Moûtiers",
    },
    operatorsNames: {
        ES: "Eurostar",
        "9F": "Eurostar",
        PEG: "Pegasus Train"
    },
    trainClass: {
        standard: "Eco",
        premium: "Eerste klas",
        title: "Reistypen",
        outOfStock: "Uitverkocht"
    }
};

export default trainNlTranslations;
